/**
 * Carries a partial write to the operator's typed preferences.
 *
 * An omitted field is left alone. Null erases the stored value so the
 * client can fall back to the organisation default.
 */
export class UpdateUserSettingsDto {
  languageId?: number | null;
  timezone?: string | null;
}
